<app-modal header="customer-account.change-account" [closable]="true" (closed)="close()">
  <div body class="my-2">
    <form [formGroup]="impersonationForm" class="d-flex flex-column gap-3" [appLoader]="loading()">
      <app-auto-complete
        label="customer-account.account-group"
        formControlName="group"
        bindValue="NOM"
        bindLabel="NOM"
        [items]="customerUserApiService.userGroupList()" />
      <app-auto-complete
        [appLoader]="loadingUser() && !loading()"
        label="customer-account.state-select-success"
        formControlName="username"
        bindValue="NOM"
        bindLabel="NOM"
        [items]="customerUserApiService.userList()" />
    </form>
  </div>
  <ng-container footer>
    <app-button
      [disabled]="impersonationForm.invalid"
      identifier="confirm-button-ok"
      variant="primary"
      text="shared.confirm"
      (clicked)="confirm()" />
    <app-button identifier="confirm-button-cancel" variant="outline-primary" text="shared.cancel" (clicked)="close()" />
  </ng-container>
</app-modal>
